import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'; // <-- IMPORT LINK
import adminService from '../../services/adminService';
import styles from './AdminProductsPage.module.scss';
import commonStyles from '../AdminOrdersPage/AdminOrdersPage.module.scss';
import ProductImageGallery from '../../components/admin/ProductImageGallery/ProductImageGallery';
import { IoTrash, IoPencil, IoAdd } from 'react-icons/io5';
import { toast } from 'react-toastify';

// const BACKEND_URL = 'http://localhost/tramhuong';
const BACKEND_URL = 'https://huongtramcomoc.vn';

const AdminProductsPage = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');

  useEffect(() => {
    loadProducts();
    adminService.getCategories().then(res => setCategories(res.data));
  }, []);

  const loadProducts = () => {
    setLoading(true);
    adminService.getAdminProducts()
      .then(response => {
        setProducts(response.data.records || []);
        setLoading(false);
      })
      .catch(err => console.error(err));
  };

  const handleDelete = (id) => {
    if (window.confirm('Bạn có chắc muốn xóa sản phẩm này? Mọi ảnh liên kết sẽ bị xóa.')) {
      adminService.deleteProduct(id)
        .then(() => {
          toast.success('Đã xóa thành công!');
          loadProducts(); // Tải lại danh sách
        })
        .catch(err => toast.error('Lỗi: ' + (err.response?.data?.message || err.message)));
    }
  };
  
  const formatPrice = (price) => new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(price);
  const filteredProducts = selectedCategory 
    ? products.filter(p => p.category_id == selectedCategory)
    : products;

  return (
    <div className={commonStyles.adminPage}>
      <div className={styles.header}>
        <h1>Quản Lý Sản Phẩm</h1>
        <div className={styles.actionsRow}>
          <select 
            value={selectedCategory} 
            onChange={(e) => setSelectedCategory(e.target.value)}
            className={styles.categoryFilter}
          >
            <option value="">-- Tất cả danh mục --</option>
            {categories.map(cat => (
              <option key={cat.id} value={cat.id}>{cat.name}</option>
            ))}
          </select>

          <Link to="/admin/products/new" className={styles.addButton}>
            <IoAdd /> Thêm Sản Phẩm
          </Link>
        </div>
      </div>

      {loading && <p>Đang tải...</p>}
      
      {!loading && (
        <table className={commonStyles.adminTable}>
          <thead>
            <tr>
              <th>ID</th>
              <th>Hình Ảnh</th>
              <th>Tên Sản Phẩm</th>
              <th>Giá</th>
              <th>Hành Động</th>
            </tr>
          </thead>
          <tbody>
            {filteredProducts.map(product => (
              <tr key={product.id}>
                <td>#{product.id}</td>
                <td>
                  <ProductImageGallery imagesString={product.all_images_str} />
                </td>
                <td>{product.name}</td>
                <td>{formatPrice(product.price)}</td>
                <td>
                  {/* SỬA THÀNH LINK */}
                  <Link to={`/admin/products/edit/${product.id}`} className={`${commonStyles.actionButton} ${styles.editButton}`}>
                    <IoPencil /> Sửa
                  </Link>
                  <button 
                    className={`${commonStyles.actionButton} ${styles.deleteButton}`}
                    onClick={() => handleDelete(product.id)}
                  >
                    <IoTrash /> Xóa
                  </button>
                </td>
              </tr>
            ))}
            {filteredProducts.length === 0 && (
              <tr>
                <td colSpan="5" style={{textAlign: 'center', padding: '20px'}}>
                  Không tìm thấy sản phẩm nào trong danh mục này.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default AdminProductsPage;